import React from 'react';
import { InstagramIcon, StarIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1F1F1F] pt-12 sm:pt-16 pb-8" data-id="element-71">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-72">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-12 mb-12 sm:mb-16 text-center md:text-left" data-id="element-73">
          {/* Brand Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-74">
            <a href="#home" className="text-2xl font-bold text-white mb-4" data-id="element-75">
              Scottsdale Patio Shades
            </a>
            <p className="text-gray-400 max-w-xs" data-id="element-76">
              Premium shade solutions for Arizona living. Manufactured in
              Phoenix, AZ.
            </p>
          </div>

          {/* Links Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-77">
            <h3 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-78">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-79">
              {['Home', 'Services', 'Products', 'Gallery', 'About', 'Contact', 'Financing'].map(link => <li key={link} data-id="element-80">
                  <a href={`#${link.toLowerCase()}`} className="text-gray-400 hover:text-gold transition-colors" data-id="element-81">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact & Social Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-82">
            <h3 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-83">
              Connect
            </h3>
            <div className="flex gap-4 mb-8" data-id="element-84">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-gold hover:text-charcoal transition-all" data-id="element-85">
                <InstagramIcon className="w-5 h-5" data-id="element-86" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-gold hover:text-charcoal transition-all" data-id="element-87">
                <StarIcon className="w-5 h-5" data-id="element-88" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-gold hover:text-charcoal transition-all" data-id="element-89">
                <GlobeIcon className="w-5 h-5" data-id="element-90" />
              </a>
            </div>
            <div className="space-y-2 text-gray-400 text-center md:text-left" data-id="element-91">
              <p data-id="element-92">602-551-1539</p>
              <p data-id="element-93">scottsdalepatioshade@gmail.com</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500" data-id="element-94">
          <p data-id="element-95">© 2026 Scottsdale Patio Shades. All rights reserved.</p>
          <p data-id="element-96">Powered by LetLois</p>
        </div>
      </div>
    </footer>;
}